import s from "./news.module.scss";
import { Container } from "../../components/container";
import { Title } from "../../components/title";
import { useEffect } from "react";
import { gsap } from "gsap";

export const News = ({ reference }) => {
  useEffect(() => {
    let ctx = gsap.context(() => {
      gsap.from(`.${s.news}`, {
        duration: 1,
        y: 100,
        opacity: 0,
      });
    }, reference);
    return () => ctx.revert();
  }, [reference]);
  return (
    <div className={s.news}>
      <Container>
        <div className={s.title}>
          <Title span={"News"} size={25}>
            Latest
          </Title>
        </div>
        <hr />
        <div className={s.image}>
          <img src={"/news_auto_x2_toned.jpg"} alt="last news" />
        </div>
      </Container>
    </div>
  );
};
